import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../components/Atomos/DropDown/Dropdown";
import DDMultiple, { Option } from "../../components/Atomos/DropDown/DDMultiple";
import InputImage from "../../components/Atomos/InputImage/InputImage";
import CalendarInput from "../../components/Atomos/Inputs/CalendarInput";
import Input from "../../components/Atomos/Inputs/Input";
import TextArea from "../../components/Atomos/Inputs/TextArea";
import TimeInput from "../../components/Atomos/Inputs/TimeInput";
import RadioButton from "../../components/Atomos/Radio/RadioButton";
import WSGCheckBox from "../../components/Atomos/Checkbox/WSGCheckBox";
import SwitchToggle from "../../components/Atomos/Switch-Toogle/Switch";
import DropdownButton from "../../components/Atomos/Buttons/DropdownButton";
import { toastInfo } from "../../utils/toast";

const InputComponentsTest: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isStaffRoute = location.pathname.includes('/staff/test-input-components');
  const [dropdownValue, setDropdownValue] = useState<any>(undefined);
  const [dropdownValue2, setDropdownValue2] = useState<any>(undefined);
  const [dropdownValue3, setDropdownValue3] = useState<any>(undefined);
  const [dropdownValue4, setDropdownValue4] = useState<any>(undefined);

  const [ddMultipleValue, setDdMultipleValue] = useState<Option[]>([]);
  const [ddMultipleValue2, setDdMultipleValue2] = useState<Option[]>([]);
  const [ddMultipleValue3, setDdMultipleValue3] = useState<Option[]>([]);

  const [inputValue, setInputValue] = useState<string>("");
  const [inputValue2, setInputValue2] = useState<string>("");
  const [inputValue3, setInputValue3] = useState<string>("");
  const [inputValue4, setInputValue4] = useState<string>("");

  const [textareaValue, setTextareaValue] = useState<string>("");
  const [textareaValue2, setTextareaValue2] = useState<string>("");
  const [textareaValue3, setTextareaValue3] = useState<string>("");

  const [calendarValue, setCalendarValue] = useState<string>("");
  const [calendarValue2, setCalendarValue2] = useState<string>("");
  const [calendarRangeValue, setCalendarRangeValue] = useState<string>("");

  const [timeValue, setTimeValue] = useState<string>("");
  const [timeValue2, setTimeValue2] = useState<string>("");
  const [timeValue3, setTimeValue3] = useState<string>("");

  const [selectedRadio, setSelectedRadio] = useState<number>(0);

  const [checkboxStates, setCheckboxStates] = useState<boolean[]>([false, false, false, false]);

  const dropdownData: Option[] = [
    { id: "1", name: "Opción 1" },
    { id: "2", name: "Opción 2" },
    { id: "3", name: "Opción 3" },
    { id: "4", name: "Opción 4" },
    { id: "5", name: "Opción 5" },
  ];

  const handleCheckboxChange = (index: number) => {
    const newStates = [...checkboxStates];
    newStates[index] = !newStates[index];
    setCheckboxStates(newStates);
  };

  const handleRadioChange = (index: number) => {
    setSelectedRadio(index);
  };

  const handleToggleStaffMode = (checked: boolean) => {
    if (checked) {
      navigate('/staff/test-input-components');
    } else {
      navigate('/test-input-components');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6 bg-white p-4 rounded-lg shadow-sm">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-font mb-2">
                Componentes de Input - Página de Pruebas
              </h1>
              <p className="text-base md:text-lg text-gray-600">
                Esta página muestra todos los componentes de input con diferentes variaciones para facilitar las pruebas en desktop, tablet y mobile.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 h-20 justify-center">
            <span className="text-base font-medium text-gray-font">
              Modo Staff:
            </span>
            <SwitchToggle
              checked={isStaffRoute}
              seter={handleToggleStaffMode}
              title="Staff Mode"
              titleFirst={false}
            />
          </div>
        </div>
        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Dropdown button
          </h2>
          <p className="mb-4 text-sm text-gray-600">
            Primary action on the left, caret opens the related options.
          </p>
          <DropdownButton
            color={isStaffRoute ? "accent" : "primary"}
            action={{
              label: "Log",
              onClick: () => toastInfo("Log"),
            }}
            items={[
              {
                id: "all-logs",
                label: "All Logs",
                onSelect: () => toastInfo("All Logs"),
              },
            ]}
          />
        </section>
        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Dropdown
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <Dropdown
                title="Dropdown Normal"
                data={dropdownData}
                selectedObjst={dropdownValue}
                seter={setDropdownValue}
                placeholder="Selecciona una opción"
                internalSearch
              />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-4">Con Required y Tooltip</h3>
              <Dropdown
                title="Dropdown Required"
                data={dropdownData}
                selectedObjst={dropdownValue2}
                seter={setDropdownValue2}
                required
                tooltip="Este es un tooltip de ayuda para el dropdown"
                placeholder="Selecciona una opción"
              />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-4">Con Error</h3>
              <Dropdown
                title="Dropdown con Error"
                data={dropdownData}
                selectedObjst={dropdownValue3}
                seter={setDropdownValue3}
                error={true}
                errormsj="Este campo es requerido"
                placeholder="Selecciona una opción"
              />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-4">Disabled</h3>
              <Dropdown
                title="Dropdown Disabled"
                data={dropdownData}
                selectedObjst={dropdownValue4}
                seter={setDropdownValue4}
                disabled
                placeholder="Selecciona una opción"
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Dropdown Múltiple
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <DDMultiple
                title="Selección Múltiple"
                objects={dropdownData}
                selectedObjst={ddMultipleValue}
                seter={setDdMultipleValue}
                placeholder="Selecciona múltiples opciones"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Error</h3>
              <DDMultiple
                title="Selección Múltiple Required"
                objects={dropdownData}
                selectedObjst={ddMultipleValue2}
                seter={setDdMultipleValue2}
                required
                error={true}
                errorMessage="Debes seleccionar al menos una opción"
                tooltip="Puedes seleccionar múltiples opciones"
                placeholder="Selecciona múltiples opciones"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <DDMultiple
                title="Selección Múltiple Disabled"
                objects={dropdownData}
                selectedObjst={ddMultipleValue3}
                seter={setDdMultipleValue3}
                disabled
                placeholder="Selecciona múltiples opciones"
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Input
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <Input
                title="Input Normal"
                name="input-normal"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="Escribe algo aquí"
                error={false}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Tooltip</h3>
              <Input
                title="Input Required"
                name="input-required"
                value={inputValue2}
                onChange={(e) => setInputValue2(e.target.value)}
                required
                tooltip="Este es un tooltip de ayuda"
                placeholder="Campo requerido"
                error={false}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Error</h3>
              <Input
                title="Input con Error"
                name="input-error"
                value={inputValue3}
                onChange={(e) => setInputValue3(e.target.value)}
                error={true}
                errorMsj="Este campo tiene un error"
                placeholder="Campo con error"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <Input
                title="Input Disabled"
                name="input-disabled"
                value="Valor deshabilitado"
                disabled
                error={false}
                placeholder="Campo deshabilitado"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Porcentaje</h3>
              <Input
                title="Input con Porcentaje"
                name="input-percentage"
                value={inputValue4}
                onChange={(e) => setInputValue4(e.target.value)}
                percentage
                error={false}
                placeholder="0"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Porcentaje</h3>
              <Input
                title="Input con Porcentaje y Disabled"
                name="input-percentage"
                value={inputValue4}
                onChange={(e) => setInputValue4(e.target.value)}
                percentage
                error={false}
                disabled={true}
                placeholder="0"
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            TextArea
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <TextArea
                title="TextArea Normal"
                name="textarea-normal"
                value={textareaValue}
                onChange={(e) => setTextareaValue(e.target.value)}
                placeholder="Escribe un texto largo aquí"
                error={false}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Tooltip</h3>
              <TextArea
                title="TextArea Required"
                name="textarea-required"
                value={textareaValue2}
                onChange={(e) => setTextareaValue2(e.target.value)}
                required
                tooltip="Este es un tooltip de ayuda para el textarea"
                placeholder="Campo requerido"
                error={false}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Error y MaxChars</h3>
              <TextArea
                title="TextArea con Error"
                name="textarea-error"
                value={textareaValue3}
                onChange={(e) => setTextareaValue3(e.target.value)}
                error={true}
                errorMsj="El texto es demasiado largo"
                maxChars={100}
                characterCount
                placeholder="Máximo 100 caracteres"
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Calendar Input
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Fecha Simple</h3>
              <CalendarInput
                title="Fecha Simple"
                type="single"
                value={calendarValue}
                onChange={setCalendarValue}
                placeholder="MM/DD/YYYY"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Error</h3>
              <CalendarInput
                title="Fecha Required"
                type="single"
                value={calendarValue2}
                onChange={setCalendarValue2}
                required
                error={true}
                errorMsj="Debes seleccionar una fecha"
                tooltip="Selecciona una fecha válida"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Rango de Fechas</h3>
              <CalendarInput
                title="Rango de Fechas"
                type="range"
                value={calendarRangeValue}
                onChange={setCalendarRangeValue}
                tooltip="Selecciona un rango de fechas"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <CalendarInput
                title="Fecha Disabled"
                type="single"
                value="01/15/2024"
                onChange={() => {}}
                disabled
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Time Input
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <TimeInput
                title="Hora Normal"
                value={timeValue}
                onChange={setTimeValue}
                placeholder="HH:MM AM/PM"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Error</h3>
              <TimeInput
                title="Hora Required"
                value={timeValue2}
                onChange={setTimeValue2}
                required
                error={true}
                errorMsj="Debes seleccionar una hora"
                tooltip="Selecciona una hora válida"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Intervalo de 15 min</h3>
              <TimeInput
                title="Hora con Intervalo"
                value={timeValue3}
                onChange={setTimeValue3}
                minuteInterval={15}
                tooltip="Los minutos están en intervalos de 15"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <TimeInput
                title="Hora Disabled"
                value="12:00 PM"
                onChange={() => {}}
                disabled
              />
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Radio Button
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <div className="flex flex-col gap-3">
                <RadioButton
                  index={0}
                  text="Opción 1"
                  selected={selectedRadio === 0}
                  handleRadioButtonChange={handleRadioChange}
                  name="radio-group-1"
                />
                <RadioButton
                  index={1}
                  text="Opción 2"
                  selected={selectedRadio === 1}
                  handleRadioButtonChange={handleRadioChange}
                  name="radio-group-1"
                />
                <RadioButton
                  index={2}
                  text="Opción 3"
                  selected={selectedRadio === 2}
                  handleRadioButtonChange={handleRadioChange}
                  name="radio-group-1"
                />
              </div>
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <div className="flex flex-col gap-3">
                <RadioButton
                  index={3}
                  text="Opción Disabled 1"
                  selected={false}
                  handleRadioButtonChange={() => {}}
                  disabled
                  name="radio-group-2"
                />
                <RadioButton
                  index={4}
                  text="Opción Disabled 2"
                  selected={true}
                  handleRadioButtonChange={() => {}}
                  disabled
                  name="radio-group-2"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Checkbox
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <div className="flex flex-col gap-3">
                <WSGCheckBox
                  index={0}
                  text="Checkbox 1"
                  checked={checkboxStates[0]}
                  handleCheckboxChange={handleCheckboxChange}
                />
                <WSGCheckBox
                  index={1}
                  text="Checkbox 2"
                  checked={checkboxStates[1]}
                  handleCheckboxChange={handleCheckboxChange}
                />
              </div>
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Error y Disabled</h3>
              <div className="flex flex-col gap-3">
                <WSGCheckBox
                  index={2}
                  text="Checkbox con Error"
                  checked={checkboxStates[2]}
                  handleCheckboxChange={handleCheckboxChange}
                  error={true}
                />
                <WSGCheckBox
                  index={3}
                  text="Checkbox Disabled"
                  checked={true}
                  handleCheckboxChange={() => {}}
                  disable={true}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="mb-6 bg-white p-4 md:p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-font mb-4 pb-2 border-b border-gray-200">
            Input Image
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Normal</h3>
              <InputImage
                title="Imagen de Perfil"
                setImage={() => {}}
                maxsize={5}
                extension="JPG, PNG"
                width={200}
                height={200}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Con Required y Error</h3>
              <InputImage
                title="Imagen Required"
                setImage={() => {}}
                required
                error={true}
                errorMsg="Debes subir una imagen"
                tooltip="Sube una imagen de perfil"
                maxsize={5}
                extension="JPG, PNG"
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Adaptive Shape</h3>
              <InputImage
                title="Imagen Adaptativa"
                setImage={() => {}}
                adaptiveShape
                width={300}
                height={200}
                maxsize={5}
              />
            </div>
            <div>
              <h3 className="text-base font-medium text-gray-700 mb-2">Disabled</h3>
              <InputImage
                title="Imagen Disabled"
                setImage={() => {}}
                disabled
                maxsize={5}
              />
            </div>
          </div>
        </section>

        <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <h3 className="text-lg font-semibold text-blue-900 mb-2">Información de Pruebas</h3>
          <p className="text-sm text-blue-800">
            Esta página está diseñada para probar todos los componentes de input en diferentes tamaños de pantalla.
            Ajusta el tamaño de la ventana del navegador para ver cómo se comportan los componentes en desktop, tablet y mobile.
            Usa el switch "Staff Mode" en la parte superior para alternar entre los estilos primary y secondary.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InputComponentsTest;

